import { createSelector } from '@ngrx/store';
import { qualificationToSurveyQualification } from '@ps/survey-utils';

import { mostRecentCacheKey } from '../../utils/cache/cache.helper';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectReference } = surveyCreationFeature;

export const selectQualificationsRecord = createSelector(
  selectReference,
  ({ qualificationsRecord }) => qualificationsRecord,
);

export const selectQuestionCategories = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.data,
);

export const selectQuestionCategoriesCachedAt = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.cachedAt,
);

export const selectIsQuestionCategoriesLoading = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.loading,
);

export const selectQuestionsRecord = createSelector(
  selectReference,
  ({ questionsRecord }) => questionsRecord,
);

export const selectQuestionsLoadingKey = createSelector(
  selectReference,
  ({ questionsLoadingKey }) => questionsLoadingKey,
);

// Location-qualification UI (Set Location section) shows one flat list at a
// time — it isn't locale-selection-aware. Bridge to the most recently loaded
// locale's qualifications so it keeps working as a survey's country/language
// changes, without needing its own "current locale" state slice.
export const selectQualifications = createSelector(
  selectQualificationsRecord,
  (record) => {
    const mostRecentKey = mostRecentCacheKey(
      Object.fromEntries(
        Object.entries(record).map(([key, entry]) => [key, entry.cachedAt]),
      ),
    );

    const qualifications = mostRecentKey
      ? (record[mostRecentKey]?.data ?? [])
      : [];

    return qualifications.map(qualificationToSurveyQualification);
  },
);
